
import React from 'react';
import { ModalProvider } from '@/contexts/ModalContext';
import EntityDetailsModal from './EntityDetailsModal';

const ModalRoot: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <ModalProvider>
      {children}
      <EntityDetailsModal />
    </ModalProvider>
  );
};

export default ModalRoot;
